const organization = {
  usage: {
    title: '团队使用情况',
    subtitle: '按时间查看团队招聘产出、积分消耗和已记录的业务活动。',
    period: '统计时间',
    periods: { today: '今天', '7d': '近 7 天', '30d': '近 30 天' },
    metrics: {
      activeMembers: '业务活跃成员',
      newJobs: '新增岗位',
      newTags: '新增标签',
      imports: '导入候选人',
      aiConsumed: '消耗 AI 积分',
      contactConsumed: '消耗联系积分',
      jobs: '组织岗位总数',
      tags: '组织标签总数',
      candidates: '组织候选人数',
    },
    tabs: {
      employees: '成员使用',
      activity: '业务活动',
      points: '积分流水',
      jobs: '员工岗位',
      tags: '员工标签',
    },
    activeHint:
      '业务活跃成员指期间创建组织岗位、标签或消耗组织积分的成员，不代表登录人数。积分消耗按实际扣费累计，不含分配和回收；退款在流水单列，不抵扣此数值。',
    partialHistory:
      '仅统计可确认组织归属的记录；岗位和标签按现存记录统计，已删除或未采集的历史无法完整还原，不包含加入组织前的个人资料。',
    missingSources: '导入、AI 检索及成员管理操作尚未完整采集，暂不纳入业务活动统计。',
    notCollected: '暂未采集',
    range: '{start} 至 {end}（UTC）',
    timeUtc: '时间（UTC）',
    lastActive: '最近业务活动（UTC）',
    details: '详情',
    inspectEmployee: '查看 {name} 的组织业务详情',
    employeeDetail: '员工业务详情',
    employeeMetricHint:
      '岗位、标签、候选人为组织内现存总量；积分消耗仅统计{period}。下方岗位和标签不受时间筛选影响。',
    memberUnavailable: '该成员记录已不可用，请刷新成员列表。',
    activityHint: '已记录的岗位、标签创建和积分变动；此列表不等同于完整操作审计。',
    ledgerHint:
      '记录实际扣费、退款、额度分配和企业池调整。扣费与退款分开记录；概览显示累计扣费，非退款后的净消耗。积分数额的含义由操作类型决定。',
    retry: '重试',
    noRecords: '所选时间内暂无记录',
    event: '操作',
    points: '积分数额',
    poolBalance: '变动后企业池',
    operator: '操作人',
    resource: '关联业务',
    organizationPool: '企业积分池',
    events: { job_created: '创建岗位', tag_created: '创建标签', points_changed: '积分变动' },
    actions: {
      grant: '开通赠予',
      renew: '续费增加',
      allocate: '分配额度',
      reclaim: '回收额度',
      consume: '积分扣费',
      refund: '积分退款',
      freeze: '冻结积分',
      unfreeze: '解冻积分',
      adjust: '调整积分',
    },
  },
  page: {
    tabs: { members: '成员管理', resources: '团队资料', usage: '使用记录' },
    memberCount: '共 {count} 位成员',
    employeeResources: '员工资料',
    moreActions: '更多成员操作',
    membersHelp: '席位与资料范围说明',
    statisticsHelp: '统计口径与数据范围',
    aiPool: '可分配 AI 积分',
    contactPool: '可分配联系积分',
    eyebrow: '组织管理',
    benefitsTitle: '席位与积分',
    memberBenefitsTitle: '我的企业权益',
  },
  data: {
    title: '团队招聘数据',
    subtitle: '查看组织成员的标签、岗位和人才积累。',
    activeMembers: '在职成员',
    employees: '员工数据',
    employee: '员工',
    allEmployees: '全部员工',
    tags: '标签',
    jobs: '岗位',
    candidates: '候选人',
    view: '查看',
    viewCandidates: '查看候选人',
    search: '搜索',
    searchEmployees: '搜索员工姓名或邮箱',
    searchResources: '搜索名称',
    tagName: '标签名称',
    jobName: '岗位名称',
    createdAt: '创建时间',
    defaultTag: '默认人才库',
    viewTags: '查看 {name} 的标签',
    viewJobs: '查看 {name} 的岗位',
    empty: '暂无符合条件的组织资料',
    scope: '仅展示已确认归属本组织的标签和岗位；加入组织前的个人资料不纳入。',
    deduplication: '候选人数按标签与岗位绑定去重统计，员工人数合计不代表组织候选人去重总数。',
    forbidden: '当前账号没有组织管理权限，请刷新组织信息。',
    unavailable: '组织数据服务尚未准备完成，请联系管理员。',
    loadFailed: '组织数据加载失败，请稍后点击刷新重试。',
    left: '已退出',
    removed: '已移除',
    inactive: '非在职',
    closed: '已关闭',
    pendingJob: '待分析',
    analyzingJob: '分析中',
    readyJob: '已分析',
    failedJob: '分析失败',
    previous: '上一页',
    next: '下一页',
    pagination: '共 {total} 条 · 第 {page} / {pages} 页',
  },
  ownerAiPoolDesc: '主账号可直接使用的企业 AI 积分',
  ownerContactPoolDesc: '主账号可直接使用的企业联系积分',
  ownerUsesPool: '直接使用企业池',
  ownerPoolHint: '主账号无需分配额度，可直接使用企业池剩余积分；已分配给成员的积分由该成员使用。',
  title: '企业席位与权益',
  adminTitle: '企业组织管理',
  inviteNotice: '您收到来自【{name}】的企业席位邀请',
  inviteAccepted: '已成功加入企业',
  inviteRejected: '已拒绝该企业邀请',
  memberContactQuotaDesc: '企业划拨的联系方式额度',
  memberAiQuotaDesc: '企业划拨的AI分析点数',
  accept: '接受邀请',
  reject: '拒绝',
  enterpriseBadge: '企业版',
  myOrganization: '我的企业',
  quotaAllocation: '额度分配',
  members: '企业成员',
  ledger: '企业流水',
  empty: '暂无数据',
  refresh: '刷新',
  loading: '加载中...',
  submit: '提交',
  confirm: '确认',
  cancel: '取消',
  status: '状态',
  actions: '操作',
  time: '时间',
  role: '角色',
  email: '注册邮箱',
  name: '名称',
  active: '生效中',
  expired: '已到期',
  pending: '待确认',
  admin: '企业管理员',
  member: '普通员工',
  enterpriseAdmin: '企业管理员',
  enterpriseMember: '普通员工',

  // 平台管理端
  adminPageTitle: '企业组织与套餐管理',
  openEnterprisePackage: '人工开通企业套餐',
  searchOrgPlaceholder: '按企业名称搜索...',
  noOrganizations: '暂无开通的企业组织',
  colOrgNameId: '企业名称 / Logto ID',
  colAdminUser: '企业管理员',
  colSeatCapacity: '席位容量 (已激/预留/总)',
  colAiPool: '企业AI积分池',
  colContactPool: '企业联系积分池',
  colValidity: '套餐有效期',
  colStatus: '状态',
  remainAvailable: '剩余 {count} 可用',
  totalCount: '总计 {count}',
  startAt: '起',
  endAt: '止',
  renewOrAdd: '续费/增购',
  transferAdmin: '转让管理员',
  editOrg: '编辑',
  deleteOrg: '删除',
  editModalTitle: '编辑企业信息',
  editModalDesc: '修改企业名称及组织状态。',
  statusDisabled: '已停用',
  statusDeleted: '已删除',
  deleteModalTitle: '删除企业组织',
  deleteModalMsg:
    '确定要删除企业“{name}”吗？删除后，该企业所有成员将立即退出企业模式并清空未消耗的企业配额，套餐将即刻终止。此操作不可逆（历史账本数据将保留归档）。',
  confirmDelete: '确认删除',
  deleteSuccess: '企业组织已成功删除',
  updateSuccess: '企业信息已更新',
  openModalTitle: '平台人工开通企业套餐',
  renewModalTitle: '企业套餐续费 / 增购',
  transferModalTitle: '协助转让企业管理员',
  transferModalDesc: '将企业“{name}”的管理员转让给新员工。新管理员必须是已注册平台账号。',
  logtoOrgId: 'Logto 组织 ID',
  logtoOrgIdPlaceholder: '例如 org_xxxxxx',
  companyName: '企业名称',
  companyNamePlaceholder: '企业名称',
  adminEmail: '唯一企业管理员注册邮箱',
  adminEmailPlaceholder: '管理员已在平台注册的邮箱',
  newAdminEmail: '新管理员已注册邮箱',
  newAdminEmailPlaceholder: '新管理员已注册邮箱',
  staffSeatCount: '员工席位数 N (总数 1+N)',
  actualTotalSeats: '实际总席位',
  seatsUnit: '席位',
  startDate: '生效开始日期',
  endDate: '生效结束日期',
  grantAiPoints: '企业 AI 总积分',
  addAiPoints: '增购 AI 积分',
  grantContactPoints: '企业联系总积分',
  addContactPoints: '增购联系积分',
  submitting: '提交中...',
  processing: '处理中...',
  confirmOpen: '确认开通',
  confirmTransfer: '确认转让',
  openSuccess: '企业套餐开通成功',
  renewSuccess: '续费成功',
  transferSuccess: '管理员转让成功',
  fillCompleteInfo: '请填写完整企业信息',

  // 企业端
  defaultOrgTitle: '企业席位与权益管理',
  noOrgAccess: '您尚未加入任何企业组织，无权访问该页面',
  expiredFrozenBadge: '套餐已到期冻结',
  orgSubtitle: '管理企业 1+N 席位、成员站内邀请、企业 AI 积分池与联系积分分配',
  inviteEmployee: '邀请员工',
  leaveOrg: '退出企业',
  expiredBannerTitle: '企业套餐已到期，企业使用权限已冻结',
  expiredBannerDesc:
    '未使用的积分已冻结保留。当前停止新增积分分配与扣费，但仍保留查看成员、取消邀请、移除员工及普通员工主动退出的基础能力。请联系平台管理员续费。',
  totalSeatCapacity: '席位总容量',
  seatCountUnit: '席',
  activatedSeats: '已激活',
  invitedSeats: '待确认',
  remainSeats: '剩余',
  aiPoolAvailable: '企业池剩余可分配 AI 积分',
  contactPoolAvailable: '企业池剩余可分配联系积分',
  totalPurchased: '总采购数额',
  packageValidUntil: '套餐有效期至',
  normalStatus: '正常生效中',
  myAvailableAiQuota: '我的可用企业 AI 积分额度',
  myAvailableContactQuota: '我的可用企业联系积分额度',
  consumedQuota: '已消耗额度',
  membersTableTitle: '企业成员与席位明细',
  membersTableSubtitle: '席位占用包含已激活与 7 天内待确认的邀请',
  colMemberEmail: '成员 / 注册邮箱',
  colSeatStatus: '席位状态',
  colAiQuota: 'AI 积分 (可用 / 已消耗)',
  colContactQuota: '联系积分 (可用 / 已消耗)',
  daysExpiry: '7天过期',
  cancelInvite: '取消邀请',
  allocateQuota: '分配额度',
  removeMember: '移除成员',
  activatedAtLabel: '激活',
  invitedAtLabel: '邀请',
  noMembers: '暂无成员',
  consumedLabel: '已消耗',

  // 邀请弹窗
  inviteModalTitle: '邀请员工加入企业',
  inviteModalDesc:
    '输入员工在 EasyHire AI 已注册的邮箱发起站内邀请。发起后将预留 1 个席位，有效期 7 天。',
  employeeEmailLabel: '员工注册邮箱',
  employeeEmailPlaceholder: '员工在平台注册的邮箱',
  sendInvite: '发送邀请',
  sending: '发送中...',
  inviteSuccess: '邀请已成功发送',
  pleaseInputEmail: '请输入受邀员工的注册邮箱',

  // 额度弹窗
  quotaModalTitle: '分配成员权益额度',
  quotaModalDesc:
    '为成员调整 AI 分析积分与联系积分可用额度，调高将从企业池划拨，调低将回收未消耗额度回企业池。',
  targetMemberLabel: '分配成员',
  aiPointsTitle: 'AI 分析积分',
  contactPointsTitle: '人才联系积分',
  poolRemainingLabel: '企业池剩余',
  currentAvailableQuota: '当前可用额度',
  consumedQuotaLabel: '累计已消耗',
  targetQuotaLabel: '目标可用额度',
  quickPresetLabel: '快速调整',
  presetCustom: '自定义输入数值',
  presetAdd100: '增配 +100 点',
  presetAdd500: '增配 +500 点',
  presetAdd1000: '增配 +1000 点',
  presetAdd10: '增配 +10 点',
  presetAdd50: '增配 +50 点',
  presetClear: '清零回收全部可用额度',
  diffIncrease: '从企业池增拨 +{count}',
  diffDecrease: '回收 {count} 至企业池',
  diffUnchanged: '额度无变动',
  exceedPoolWarning: '增拨数额超出企业池可用剩余！',
  pointsTypeLabel: '积分类型',
  aiPointsOption: 'AI 积分 (企业池剩余: {pool})',
  contactPointsOption: '联系积分 (企业池剩余: {pool})',
  confirmAdjust: '确认调整',
  adjustSuccess: '额度已调整生效',

  // 确认对话框
  cancelInviteConfirmTitle: '取消邀请确认',
  cancelInviteConfirmMsg: '确定要取消此邀请吗？预留的席位将立即释放。',
  cancelInviteSuccess: '邀请已取消，席位已释放',
  removeMemberConfirmTitle: '移除成员确认',
  removeMemberConfirmMsg:
    '确定要移除成员 {name} 吗？未消耗的额度将全额回收至企业池，成员席位立即释放。',
  removeMemberSuccess: '成员已移除',
  leaveOrgConfirmTitle: '退出企业确认',
  leaveOrgConfirmMsg:
    '确定要退出当前企业吗？未消耗的额度将返还给企业池，退出后您将恢复为个人模式。',
  // 平台积分池调整
  adjustPoints: '调整积分',
  adjustPointsModalTitle: '调整企业积分池',
  adjustPointsModalDesc: '为该企业的公共积分池人工增减额度或直接设定数值，变更将记入审计流水。',
  currentAiPool: 'AI 积分池当前余额',
  currentContactPool: '联系积分池当前余额',
  adjustTypeLabel: '调整积分类型',
  adjustModeLabel: '调整模式',
  adjustModeAdd: '增加 (+)',
  adjustModeDeduct: '扣减 (-)',
  adjustModeSet: '直接设为 (=)',
  adjustAmountLabel: '变动数值',
  adjustAmountPlaceholder: '请输入调整数值',
  adjustReasonLabel: '调整原因 / 备注',
  adjustReasonPlaceholder: '请输入调整原因（如商务补发、客户退款扣减等，选填）',
  previewPoolLabel: '预计调整后余额',
  exceedDeductWarning: '扣减数额不能大于当前池可用余额！',
  adjustPointsSuccess: '企业积分池调整成功',
}

export default organization
